module.exports = __webpack_public_path__ + "static/ConfidentialPro-e4b991aa25b743895fa59df73f4abcce.woff2";